import type { Theme } from '@mui/material/styles';

// Layout values shared by the phone and touch adaptations, so a popover, a toast or a small
// icon button sizes itself the same way in every feature.

// A popover's widest extent on a narrow screen: the viewport less a gutter of theme.spacing(2) on
// each side. An sx callback, so the gutter follows the theme's spacing unit.
export const viewportGutterMaxWidth = (theme: Pick<Theme, 'spacing'>): string => `calc(100vw - ${theme.spacing(4)})`;

// A toast on a phone sits just above the home indicator instead of the default offset.
export const PHONE_TOAST_SX = {
  bottom: (theme: Theme) => `calc(${theme.spacing(1)} + env(safe-area-inset-bottom))`,
} as const;

// The smallest target a finger hits reliably, for icon buttons on a touch pointer.
export const TOUCH_TARGET_SX = { minWidth: 40, minHeight: 40 } as const;
